<script setup>
// Logotipo textual "UP AVIATION".
</script>

<template>
  <span class="inline-flex items-baseline font-semibold tracking-[0.16em] leading-none" role="img" aria-label="UP Aviation">
    <span class="text-[1.05em]">UP</span>
    <span class="ml-[0.35em]">AVIATION</span>
  </span>
</template>
